export const getDaysInMonth = (year: number, month: number) => {
  // date as 0 gets the day before the first day of the month,
  // which is the last day of the previous month!
  // month + 1 is correct here :3
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  return Array(daysInMonth)
    .fill(0)
    .map((_, i) => ({ value: i + 1, label: `${i + 1}` }));
};

export const getMonthNames = () => {
  return Array(12)
    .fill(0)
    .map((_, i) => ({
      value: i,
      label: new Date(0, i, 1).toLocaleString(undefined, { month: "long" }),
    }));
};

export const getLastNumberOfYears = (num: number) => {
  return Array(num)
    .fill(new Date().getFullYear())
    .map((year, i) => ({
      value: year - i,
      label: `${year - i}`,
    }));
};
